import { environment } from '../../../environments/environment';
import {
  Component,
  Inject,
  PLATFORM_ID,
  ChangeDetectorRef,
  AfterViewInit,
  OnDestroy
} from '@angular/core';
import { isPlatformBrowser,isPlatformServer } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { CatalogService } from '../../modules/catalog/catalog.service';
import { CommonModule, DOCUMENT } from '@angular/common';
import { DataService } from './../../shared/services/data.service';
import { BasketService } from '../../modules/basket/basket.service';
import { RouterLink } from '@angular/router';
import { Navbar } from "../navbar/navbar";
import { NgZone } from '@angular/core';
@Component({
  selector: 'app-header',
  imports: [CommonModule, RouterLink, Navbar],
  templateUrl: './header.html',
  styleUrl: './header.css',
})
export class Header implements AfterViewInit, OnDestroy {
  days = 0;
  hours = 0;
  minutes = 0;
  daysStr = "0";
  hoursStr = "0";
  minutesStr = "0";
  seconds = 0;
  private intervalId: any;
  private isBrowser: boolean;
  operators = ['orange', 'sfr', 'bouygues'];
  allProducts: Product[] = [];
  private timer: any;
  forfaits: Record<string, Product[]> = {};
  momentForfaits: Record<string, Product[]> = {};
  momentProducts: Product[] = [];
  counter = '0';
  bsktUrl= "/";
constructor(private http: HttpClient,
  @Inject(PLATFORM_ID) private platformId: Object,private dataService: DataService,
  private cdr: ChangeDetectorRef,private basketService: BasketService,
  @Inject(DOCUMENT) private document: Document,private catalogService: CatalogService,
  private ngZone: NgZone) {
  this.isBrowser = isPlatformBrowser(this.platformId);
}
 ngOnInit() {
  
    if (isPlatformBrowser(this.platformId)) {
      var contactId = localStorage.getItem("contactId");
      var counter = localStorage.getItem("counter");
      if(contactId != undefined){
        this.checkValidityBasket(contactId);
        if (counter != '0' && counter != undefined) {
          this.counter = counter;
        }
      }
      this.getActiveProduct(); 
    }
  }
  operatorFormat: { [key: string]: string } = {
  'orange': 'Orange',
  'sfr': 'SFR',
  'bouygues': 'Bouygues',
  'free': 'Free'
};
  createBasket(product:any){
    this.basketService.createBasket(product);
  }
  checkValidityBasket(contactId:any){
    var publicKey:any ="";
    if (isPlatformBrowser(this.platformId)) {
      publicKey = localStorage.getItem('contactId');
    }
    if (publicKey == null) {
      publicKey="";
    } else {
      const isSSR = isPlatformServer(this.platformId);
      const apiUrl = isSSR
      ? `${environment.apiUrlLocal}`
      : `${environment.apiUrl}`;
      let url = `${apiUrl}/Basket/GetBasket?id=` + publicKey;
      this.dataService.get(url, publicKey).subscribe(
        data => {
          var basket = data.result;
          var bskt_createDate = new Date(basket.createDate);
          var currentDate = new Date();
          bskt_createDate.setDate(bskt_createDate.getDate() + 1);
          if (!basket?.createDate) return;
          
          if(bskt_createDate < currentDate){
            if (isPlatformBrowser(this.platformId)) {
              this.bsktUrl ="/";
              this.counter = "0";
              localStorage.clear();
            }
          } else {
            this.bsktUrl = '/panier/'+publicKey;
          }
          this.cdr.markForCheck();
        },
        errorResponse => {}
      );
    }
  }
  getActiveProduct() {
    this.catalogService.GetActiveProductForV2().subscribe(
      data => {
        // Les données arrivent déjà parfaitement nettoyées !
        this.allProducts = Object.values(data).flat() as Product[];

        this.filterForfaits();
        
        if (this.isBrowser && isPlatformBrowser(this.platformId)) {
          this.initMomentTimer();
        }
      }
    );
  }
  initMomentTimer() {
    if (!this.isBrowser) return;

    if (!this.momentProducts || this.momentProducts.length === 0) return;

    const endDate = new Date(this.momentProducts[0].dateEndValidation);
    setTimeout(() => {
      this.startTimer(endDate);
      this.cdr.detectChanges();
    });
  }
  ngAfterViewInit() {
  }

  startTimer(time: Date) {
    this.calculateTime(time);
    this.ngZone.runOutsideAngular(() => {
      this.intervalId = setInterval(() => {
        this.ngZone.run(() => {
          this.calculateTime(time);
          this.cdr.markForCheck(); 
        });
        
      }, 1000);
    });
  }
filterForfaits(): void {
  if (!this.allProducts || this.allProducts.length === 0) return;

  // L'URL est déjà nettoyée par getActiveProduct(), on se contente de classer
  this.forfaits = this.allProducts.reduce((acc: Record<string, Product[]>, product: Product) => {
    if (!acc[product.operators]) {
      acc[product.operators] = [];
    }
    acc[product.operators].push(product);
    return acc;
  }, {});

  // Tri par volume (Gigas)
  Object.keys(this.forfaits).forEach(op => {
    this.forfaits[op].sort((a, b) => (a.maxVolume || 0) - (b.maxVolume || 0));
  });

  // Mise à jour des produits du moment (clonés et nettoyés automatiquement)
  this.momentProducts = this.allProducts
    .filter(p => p.isMomenProduct === true)
    .sort((a, b) => b.maxVolume - a.maxVolume);
}
  filterForfaitsOld(): void {
    if (!Array.isArray(this.allProducts) || this.allProducts.length === 0) {
      console.warn('No products to filter');
      return;
    }
    const filtered = this.allProducts;
    this.forfaits = filtered.reduce((acc: Record<string, Product[]>, originalProduct: Product) => {
      // 1. On crée une copie (clone) du produit pour ne pas modifier le cache partagé
      const product = { ...originalProduct };

      if (!acc[product.operators]) {
        acc[product.operators] = [];
      }
      // const lastDashIndex = product.urlName.lastIndexOf('-');
      // var slug = product.urlName.substring(0, lastDashIndex);
      
      // product.urlName = slug; // 2. On modifie uniquement la copie locale !
      
      acc[product.operators].push(product);
      return acc;
    }, {});
    Object.keys(this.forfaits).forEach(operator => {
      this.forfaits[operator].sort((a: Product, b: Product) => {
        const volA = a.maxVolume ?? 0;
        const volB = b.maxVolume ?? 0;
        return volA - volB;
      });
    });
    const filtered2 = this.allProducts.filter((product: Product) => product.isMomenProduct === true);
    this.momentForfaits = filtered2.reduce((acc: Record<string, Product[]>, product: Product) => {
      if (!acc[product.operators]) {
        acc[product.operators] = [];
      }
      return acc;
    }, {});
    this.momentProducts = this.allProducts.filter(product => product.isMomenProduct === true).sort((a, b) => b.maxVolume - a.maxVolume);
  }
  calculateTime(time: Date) {
    const end = new Date(time).getTime();
    const now = Date.now();
    const diff = end - now;
    if (diff <= 0) {
      if (this.intervalId) {
         clearInterval(this.intervalId);
      }
      this.daysStr = "00";
      this.hoursStr = "00";
      this.minutesStr = "00";
      return;
    }
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    this.daysStr = days.toString().padStart(2, '0');
    this.hoursStr = hours.toString().padStart(2, '0');
    this.minutesStr = minutes.toString().padStart(2, '0');
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
  getOperators(forfait:any): string {
    return forfait.operator;
  }
}
export interface Product {
  operators: string;
  isMomenProduct: boolean;
  prix?: string;
  gigas?: string;
  reseau?: string;
  urlName: string;
  id?: string;
  classification?: string;
  promo?: boolean;
  simPrice?:number;
  maxVolume:number;
  maxTarif:number;
  fonctionalites?: string;
  fonctionalitesList?: any;
  forfaitRoamingEuropVolume?: string;
  dateEndValidation: Date;
}